<template>
    <div class="scv-check-box">
        <input type="checkbox" :id=id v-bind:disabled="disabled" v-model="isFalse" @change="changeState" />
        <label :for=id class="scv-check-label">{{ caption }}</label>
    </div>
    <div class="android_setting_sub_btn">
        <div class="d-flex align-items-center">
            <div v-for="(option, index) in falseOptions" :key="option.value"
                :class="[{ 'horizontal_margine': index !== 0 }]">
                <div class="d-flex flex-row">
                    <label :class="['scv-check-label-box']">
                        <input class="scv-check-label" type="radio" :value="option.value" v-model="falseSelection"
                            v-bind:disabled="disabled || !isFalse" @change="changeStateSub(option.change)" />
                        <span>{{ option.label }}</span>
                    </label>
                    <InformationManual v-if=option.information :arMessage="[option.information]" :dispMode="1"
                        style="margin-left:4px;" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
// 抽象化して使いまわせるようにしているが
// デザイン追従でslotなどを多用したりv-ifが大量になるくらいなら
// Componentの規模的にもコピーして複製推奨

import { ref, computed, watch } from 'vue'
import { MessageUtil } from '@/models/Message/MessageUtil';
import InformationManual from '@/components/InformationManual.vue';

// --- Props ---
interface Props {
    modelValue: string;
    disabled: boolean;
    id: string;
    caption: string
    trueValue: string;
    falseOptions: {
        label: string
        value: string
        information: string | undefined
        change: string | undefined
    }[]
}
const props = withDefaults(defineProps<Props>(), {
});

// --- Emits ---
interface Emits {
    (e: 'update:modelValue', value: string): void
    (e: 'changeState'): void
}
const emit = defineEmits<Emits>();

// --- 外部値 ---
const externalValue = computed(() => props.modelValue ?? props.trueValue)

// --- 内部状態（チェック + ラジオ）---
const isFalse = ref(false)
const falseSelection = ref<string>(props.falseOptions[0]?.value ?? '')

// --- 外部値 → 内部値の初期化 ---
watch(
    externalValue,
    (val) => {
        if (val === props.trueValue) {
            isFalse.value = false;
        } else {
            isFalse.value = true;
            falseSelection.value = props.falseOptions.find(opt => opt.value === val)?.value
                ?? props.falseOptions[0]?.value;
        }
    },
    { immediate: true }
)

// --- 内部値 → 外部へ出力 ---
watch([isFalse, falseSelection], () => {
    const emitValue = isFalse.value ? falseSelection.value : props.trueValue;
    emit('update:modelValue', emitValue);
})

// --- radioのリセット ---
const resetSelectState = ((): void => {
    isFalse.value = false;
    falseSelection.value = props.falseOptions[0]?.value ?? '';
});

// --- 変更を親に通知 ---
const changeState = ((): void => {
    emit('changeState');
});

// --- 変更を親に通知 ---
const changeStateSub = ((message: string | undefined): void => {
    if(message){
        MessageUtil.MessageBoxV2(message, null, null, MessageUtil.MB_ICON_WARNING);
    }
    emit('changeState');
});

defineExpose({
    resetSelectState
});
</script>

<style scoped>
@import "../../../assets/css/setting.css";
.horizontal_margine {
    margin-left: 24px;
}
</style>
